(function () {
  "use strict";

  /* ----- BD Stoffmuster Media (tabs + list swipers + video play) ----- */
  function BD_StoffMuster_Media(container) {
    var sectionId = container.getAttribute("data-section-id");
    var tabsEl = sectionId ? container.querySelector("#bd-stoffmuster-media-tabs-" + sectionId) : null;
    var blockItems = container.querySelectorAll(".bd-find-the-series__block-item");

    // Multi-select filter on a single panel. Empty set = show all items.
    var selected = {};

    function selectedCount() {
      return Object.keys(selected).length;
    }

    function getBlocksSwiper() {
      var el = container.querySelector(".bd-find-the-series__blocks.swiper");
      return el && el.swiper ? el.swiper : null;
    }

    function applyFilter() {
      var showAll = selectedCount() === 0;
      // Re-query each time so Swiper loop clones (created after init) stay in sync.
      container.querySelectorAll(".bd-stoffmuster-media__tab").forEach(function (tab) {
        var idx = tab.getAttribute("data-block-index");
        tab.classList.toggle("bd-stoffmuster-media__tab--active", !showAll && !!selected[idx]);
      });
      blockItems.forEach(function (item) {
        var idx = item.getAttribute("data-product-index");
        var visible = showAll || !!selected[idx];
        item.classList.toggle("bd-find-the-series__block-item--hidden", !visible);
      });
      var sw = getBlocksSwiper();
      if (sw) sw.update();
    }

    function toggleIndex(index) {
      var i = parseInt(index, 10);
      if (isNaN(i) || i < 0) return;
      var key = String(i);
      if (selected[key]) {
        delete selected[key];
      } else {
        selected[key] = true;
      }
      applyFilter();
    }

    var isSwiping = false;

    function getTabsSwiper() {
      return window.bdStoffmusterMediaSwipers && window.bdStoffmusterMediaSwipers[sectionId];
    }

    if (tabsEl) {
      tabsEl.addEventListener("click", function (e) {
        if (isSwiping) return;
        var slide = e.target.closest(".swiper-slide");
        var btn = e.target.closest(".bd-stoffmuster-media__tab");
        if (!slide || !btn) return;
        var swiper = getTabsSwiper();
        if (swiper) {
          if (swiper.params.loop) {
            var realIndex = parseInt(slide.getAttribute("data-swiper-slide-index"), 10);
            if (!isNaN(realIndex)) swiper.slideToLoop(realIndex);
          } else {
            var idx = Array.prototype.indexOf.call(swiper.slides, slide);
            if (idx > -1) swiper.slideTo(idx);
          }
        }
        toggleIndex(btn.getAttribute("data-block-index"));
      });
    }

    function initTabsSwiper() {
      if (typeof Swiper === "undefined") {
        setTimeout(initTabsSwiper, 100);
        return;
      }
      if (!tabsEl || tabsEl.swiper) return;
      var swiper = new Swiper(tabsEl, {
        slidesPerView: "auto",
        spaceBetween: 8,
        centeredSlides: true,
        loop: true,
        breakpoints: {
          750: {
            centeredSlides: false,
            loop: false,
            spaceBetween: 20
          }
        }
      });
      if (!window.bdStoffmusterMediaSwipers) window.bdStoffmusterMediaSwipers = {};
      window.bdStoffmusterMediaSwipers[sectionId] = swiper;
    }

    function initListSwipers() {
      if (typeof Swiper === "undefined") {
        setTimeout(initListSwipers, 100);
        return;
      }
      var listEls = container.querySelectorAll(".bd-stoffmuster-media__list.swiper");
      listEls.forEach(function (listEl) {
        if (listEl.swiper) return;
        new Swiper(listEl, {
          slidesPerView: "auto",
          spaceBetween: 8,
          centeredSlides: true,
          loop: true,
          breakpoints: {

          }
        });
      });
    }

    initTabsSwiper();
    initListSwipers();

    // container.addEventListener("click", function (e) {
    //   var playBtn = e.target.closest("[data-video-play]");
    //   if (!playBtn) return;
    //   var card = playBtn.closest(".bd-stoffmuster-media__card");
    //   var wrapper = card ? card.querySelector(".bd-stoffmuster-media__video-wrapper") : null;
    //   if (!wrapper) return;
    //   var poster = wrapper.querySelector(".bd-stoffmuster-media__video-poster");
    //   var videoContainer = wrapper.querySelector(".bd-stoffmuster-media__video-container");
    //   var videoEl = wrapper.querySelector(".bd-stoffmuster-media__video-el");
    //   if (poster) poster.hidden = true;
    //   if (videoContainer) {
    //     videoContainer.hidden = false;
    //     if (videoEl) videoEl.play();
    //   }
    // });
  }

  /* ----- BD Stoffmuster Header (menu list swiper) ----- */
  function initHeaderSection(container) {
    var listEl = container.querySelector(".bd-stoffmuster-header__menu-list.swiper");
    if (!listEl || listEl.swiper) return;

    function initSwiper() {
      if (typeof Swiper === "undefined") {
        setTimeout(initSwiper, 100);
        return;
      }
      new Swiper(listEl, {
        slidesPerView: "auto",
        spaceBetween: 8,
        centeredSlides: true,
        loop: true,
        breakpoints: {
          750: {
            spaceBetween: 20,
            centeredSlides: false,
            loop: false,
          }
        }
      });
    }

    initSwiper();

    // Handle scroll to selection section on menu item click
    var menuItems = container.querySelectorAll("[data-scroll-to-product]");
    menuItems.forEach(function (menuItem) {
      menuItem.addEventListener("click", function () {
        var productId = this.getAttribute("data-product-id");
        if (!productId) return;

        var targetSection = document.querySelector('.bd-stoffmuster-selection[data-product-id="' + productId + '"]');
        if (targetSection) {
          var offset = 100;
          var elementPosition = targetSection.getBoundingClientRect().top;
          var offsetPosition = elementPosition + window.pageYOffset - offset;

          window.scrollTo({
            top: offsetPosition,
            behavior: "smooth"
          });
        }
      });
    });
  }

  /* ----- BD Stoffmuster Material (slider swiper) ----- */
  function BD_StoffMuster_Material(container) {
    var sliderEl = container.querySelector(".bd-stoffmuster-material__slider.swiper");
    if (!sliderEl || sliderEl.swiper) return;

    function initSwiper() {
      if (typeof Swiper === "undefined") {
        setTimeout(initSwiper, 100);
        return;
      }
      new Swiper(sliderEl, {
        slidesPerView: "auto",
        spaceBetween: 0,
        breakpoints: {
          750: {
            spaceBetween: 8
          }
        }
      });
    }

    initSwiper();
  }

  function BD_Stoffmuster_Selection(container) {
    var seriesTooltip = container.querySelector(".bd-stoffmuster-selection__series-tooltip");
    var detailsModal = container.querySelector(".bd-stoffmuster-modal--details");

    function showModal(modal) {
      if (modal) {
        modal.setAttribute("aria-hidden", "false");
        document.body.classList.add("bd-stoffmuster-modal-open");
      }
    }

    function hideModal(modal) {
      if (modal) {
        modal.setAttribute("aria-hidden", "true");
        document.body.classList.remove("bd-stoffmuster-modal-open");
      }
    }

    function showTooltip(tooltip) {
      if (tooltip) tooltip.setAttribute("aria-hidden", "false");
    }

    function hideTooltip(tooltip) {
      if (tooltip) tooltip.setAttribute("aria-hidden", "true");
    }

    container.addEventListener("click", function (e) {
      var tab = e.target.closest(".bd-stoffmuster-selection__tab");
      if (!tab || !container.contains(tab)) return;
      var tabType = tab.dataset.tab;
      if (tabType === "series" && seriesTooltip) {
        showTooltip(seriesTooltip);
      } else if (tabType === "details" && detailsModal) {
        e.preventDefault();
        showModal(detailsModal);
      }
    });

    if (seriesTooltip) {
      var tooltipCloseBtn = seriesTooltip.querySelector(".bd-stoffmuster-selection__series-tooltip-close");
      if (tooltipCloseBtn) {
        tooltipCloseBtn.addEventListener("click", function () {
          hideTooltip(seriesTooltip);
        });
      }
      document.addEventListener("click", function (e) {
        if (
          seriesTooltip.getAttribute("aria-hidden") === "false" &&
          !seriesTooltip.contains(e.target) &&
          !e.target.closest("[data-tooltip-trigger]")
        ) {
          hideTooltip(seriesTooltip);
        }
      });
    }

    container.addEventListener("click", function (e) {
      var item = e.target.closest(".bd-stoffmuster-selection__item");
      if (!item || !container.contains(item)) return;
      var itemId = item.getAttribute("data-item-id");
      if (!itemId || !window.bdStoffmusterStickyBar) return;

      var isSelected = item.classList.contains("bd-stoffmuster-selection__item--selected");
      if (isSelected) {
        item.classList.remove("bd-stoffmuster-selection__item--selected");
        if (window.bdStoffmusterStickyBar.clearSlot) {
          window.bdStoffmusterStickyBar.clearSlot(itemId);
        }
      } else if (window.bdStoffmusterStickyBar.setItem) {
        var wasAdded = window.bdStoffmusterStickyBar.setItem(itemId, {
          imageUrl: item.getAttribute("data-sticky-bar-image") || "",
          title: item.getAttribute("data-sticky-bar-title") || "",
          sku: item.getAttribute("data-variant-sku") || ""
        }, item);
        if (wasAdded) {
          item.classList.add("bd-stoffmuster-selection__item--selected");
        }
      }
    });

    if (detailsModal) {
      container.querySelectorAll("[data-stoffmuster-modal-close]").forEach(function (el) {
        el.addEventListener("click", function () {
          var targetId = this.getAttribute("data-modal-target");
          var modal = targetId ? document.getElementById(targetId) : null;
          if (modal) hideModal(modal);
        });
      });
      detailsModal.addEventListener("click", function (e) {
        if (e.target.classList.contains("bd-stoffmuster-modal__overlay")) {
          hideModal(detailsModal);
        }
      });
    }

    document.addEventListener("keydown", function (e) {
      if (e.key !== "Escape") return;
      if (seriesTooltip && seriesTooltip.getAttribute("aria-hidden") === "false") {
        hideTooltip(seriesTooltip);
      }
      if (detailsModal && detailsModal.getAttribute("aria-hidden") === "false") {
        hideModal(detailsModal);
      }
    });
  }

  /* ----- BD Stoffmuster Sticky Bar ----- */
  function BD_StoffMuster_Sticky_Bar(container) {
    var slotsContainer = container && container.querySelector(".bd-stoffmuster-sticky-bar__slots");
    if (!container || !slotsContainer) return;

    if (slotsContainer.swiper) {
      slotsContainer.swiper.destroy(true, true);
    }
    var itemIdToItem = {};
    var slotsWrapper = slotsContainer.querySelector(".swiper-wrapper");
    var emptySlotSvgUrl = "https://cdn.shopify.com/s/files/1/0732/7878/3807/files/4_51fe6f3f-6b0c-421d-8c63-cdcfcc193a59.svg?v=1783934105";
    var MAX_SELECTION_COUNT = 5;
    var DEFAULT_SLOT_COUNT = MAX_SELECTION_COUNT;

    function removeIconSvg() {
      var s = document.createElementNS("http://www.w3.org/2000/svg", "svg");
      s.setAttribute("width", "13");
      s.setAttribute("height", "1");
      s.setAttribute("viewBox", "0 0 13 1");
      s.setAttribute("aria-hidden", "true");
      s.innerHTML = "<path d=\"M0.5 0.5H12.5\" stroke=\"#F9F7F5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>";
      return s;
    }

    function getSelectedCount() {
      return Object.keys(itemIdToItem).length;
    }

    function updateCtaState() {
      var cta = container.querySelector("[data-sticky-bar-cta]");
      if (!cta) return;
      var hasSelection = getSelectedCount() > 0;
      cta.classList.toggle("is-disabled", !hasSelection);
      cta.setAttribute("aria-disabled", hasSelection ? "false" : "true");
      if (hasSelection) {
        cta.removeAttribute("tabindex");
      } else {
        cta.setAttribute("tabindex", "-1");
      }
    }

    function fillSlot(slot, itemId, data, itemEl) {
      itemIdToItem[itemId] = itemEl || null;
      slot.className = "bd-stoffmuster-sticky-bar__slot bd-stoffmuster-sticky-bar__slot--filled";
      slot.setAttribute("data-item-id", itemId);
      slot.setAttribute("data-article-name", data.title || "");
      slot.setAttribute("data-article-number", data.sku || "");
      slot.innerHTML = "";
      if (data.imageUrl) {
        var img = document.createElement("img");
        img.src = data.imageUrl;
        img.alt = data.title || "";
        img.loading = "lazy";
        slot.appendChild(img);
      }
      var removeBtn = document.createElement("button");
      removeBtn.type = "button";
      removeBtn.className = "bd-stoffmuster-sticky-bar__slot-remove";
      removeBtn.setAttribute("aria-label", "Remove");
      removeBtn.appendChild(removeIconSvg());
      removeBtn.addEventListener("click", function (e) {
        e.preventDefault();
        e.stopPropagation();
        clearSlot(itemId);
      });
      slot.appendChild(removeBtn);
      updateCtaState();
    }

    function createSlotSlide() {
      if (!slotsWrapper) return null;
      var slideHtml =
        '<div class="swiper-slide" data-dynamic-slot="true">' +
        '<div class="bd-stoffmuster-sticky-bar__slot bd-stoffmuster-sticky-bar__slot--empty" role="img">' +
        '<img src="' + emptySlotSvgUrl + '" alt="" aria-hidden="true">' +
        "</div></div>";
      if (slotsContainer.swiper) {
        slotsContainer.swiper.appendSlide(slideHtml);
      } else {
        slotsWrapper.insertAdjacentHTML("beforeend", slideHtml);
      }
      var slide = slotsWrapper.lastElementChild;
      return slide ? slide.querySelector(".bd-stoffmuster-sticky-bar__slot") : null;
    }

    function removeLastDynamicSlide() {
      if (!slotsWrapper || !slotsWrapper.lastElementChild) return false;
      var lastSlide = slotsWrapper.lastElementChild;
      if (lastSlide.getAttribute("data-dynamic-slot") !== "true") return false;
      if (slotsContainer.swiper) {
        var slideIndex = Array.prototype.indexOf.call(slotsWrapper.children, lastSlide);
        if (slideIndex > -1) slotsContainer.swiper.removeSlide(slideIndex);
        else lastSlide.remove();
      } else {
        lastSlide.remove();
      }
      return true;
    }

    function getFilledItems(excludeItemId) {
      var items = [];
      container.querySelectorAll(".bd-stoffmuster-sticky-bar__slot--filled").forEach(function (slot) {
        var id = slot.getAttribute("data-item-id");
        if (!id || id === excludeItemId) return;
        var img = slot.querySelector("img");
        items.push({
          itemId: id,
          data: {
            title: slot.getAttribute("data-article-name") || "",
            sku: slot.getAttribute("data-article-number") || "",
            imageUrl: img ? img.src : ""
          },
          itemEl: itemIdToItem[id] || null
        });
      });
      return items;
    }

    function ensureSlotCount(count) {
      var target = Math.max(DEFAULT_SLOT_COUNT, count);
      var slots = container.querySelectorAll(".bd-stoffmuster-sticky-bar__slot");
      while (slots.length < target) {
        createSlotSlide();
        slots = container.querySelectorAll(".bd-stoffmuster-sticky-bar__slot");
      }
      while (slots.length > target) {
        if (!removeLastDynamicSlide()) break;
        slots = container.querySelectorAll(".bd-stoffmuster-sticky-bar__slot");
      }
      return container.querySelectorAll(".bd-stoffmuster-sticky-bar__slot");
    }

    function renderSlots(filledItems) {
      var slots = ensureSlotCount(filledItems.length);
      for (var i = 0; i < slots.length; i++) {
        if (i < filledItems.length) {
          fillSlot(slots[i], filledItems[i].itemId, filledItems[i].data, filledItems[i].itemEl);
        } else {
          resetSlotEmpty(slots[i]);
        }
      }
      if (slotsContainer.swiper) slotsContainer.swiper.update();
      updateCtaState();
    }

    function findSlotForItem(itemId) {
      var existing = container.querySelector('.bd-stoffmuster-sticky-bar__slot[data-item-id="' + itemId + '"]');
      if (existing) return existing;

      var filledSlots = container.querySelectorAll(".bd-stoffmuster-sticky-bar__slot--filled");
      if (filledSlots.length >= MAX_SELECTION_COUNT) return null;

      var emptySlots = container.querySelectorAll(".bd-stoffmuster-sticky-bar__slot--empty");
      for (var i = 0; i < emptySlots.length; i++) {
        if (!emptySlots[i].getAttribute("data-item-id")) return emptySlots[i];
      }

      return null;
    }

    function setItem(itemId, data, itemEl) {
      if (!itemId) return false;
      var slot = findSlotForItem(itemId);
      if (!slot) return false;
      fillSlot(slot, itemId, data || {}, itemEl);
      if (slotsContainer.swiper) slotsContainer.swiper.update();
      updateCtaState();
      return true;
    }

    function resetSlotEmpty(slot) {
      slot.className = "bd-stoffmuster-sticky-bar__slot bd-stoffmuster-sticky-bar__slot--empty";
      slot.removeAttribute("data-item-id");
      slot.removeAttribute("data-article-name");
      slot.removeAttribute("data-article-number");
      slot.innerHTML = "";
      var img = document.createElement("img");
      img.src = emptySlotSvgUrl;
      img.alt = "";
      img.setAttribute("aria-hidden", "true");
      slot.appendChild(img);
    }

    function clearSlot(itemId) {
      if (!itemId) return;
      var item = itemIdToItem[itemId];
      if (item) item.classList.remove("bd-stoffmuster-selection__item--selected");
      delete itemIdToItem[itemId];
      renderSlots(getFilledItems(itemId));
      updateCtaState();
    }

    function clearAll() {
      Object.keys(itemIdToItem).forEach(function (id) {
        var item = itemIdToItem[id];
        if (item) item.classList.remove("bd-stoffmuster-selection__item--selected");
      });
      itemIdToItem = {};
      renderSlots([]);
      updateCtaState();
    }

    window.bdStoffmusterStickyBar = { setItem: setItem, clearSlot: clearSlot, clearAll: clearAll };

    function showBar() {
      container.classList.add("bd-stoffmuster-sticky-bar--ready");
      container.setAttribute("aria-hidden", "false");
    }

    function initSwiper() {
      if (typeof Swiper === "undefined") {
        setTimeout(initSwiper, 100);
        return;
      }
      if (slotsContainer.swiper) return;
      new Swiper(slotsContainer, {
        slidesPerView: "auto",
        spaceBetween: 24,
        centeredSlides: true,
        centeredSlidesBounds: true,
        breakpoints: {
          750: {
            centeredSlides: false,
            centeredSlidesBounds: false,
            spaceBetween: 32,
          }
        }
      });
      var resizeTimer;
      window.addEventListener("resize", function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function () {
          if (slotsContainer.swiper) slotsContainer.swiper.update();
        }, 100);
      });
      showBar();
    }
    initSwiper();

    function initHideOnFooter() {
      var footer = document.querySelector(".shopify-section-group-footer-group");
      if (!footer || typeof IntersectionObserver === "undefined") return;
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              container.classList.add("bd-stoffmuster-sticky-bar--hidden");
            } else {
              container.classList.remove("bd-stoffmuster-sticky-bar--hidden");
            }
          });
        },
        { root: null, threshold: 0 }
      );
      observer.observe(footer);
    }
    initHideOnFooter();

    var orderModal = document.getElementById("bd-stoffmuster-order-modal");
    var orderForm = orderModal && orderModal.querySelector("[data-order-form]");
    var orderSwatchesWrapper = orderModal && orderModal.querySelector("[data-order-swatches]");
    var orderSwatchesContainer = orderSwatchesWrapper && orderSwatchesWrapper.parentElement;
    var orderStep1 = orderModal && orderModal.querySelector(".bd-stoffmuster-order-modal__step[data-step=\"1\"]");
    var orderStep2 = orderModal && orderModal.querySelector(".bd-stoffmuster-order-modal__step[data-step=\"2\"]");
    var orderCloseStep2 = orderModal && orderModal.querySelector(".bd-stoffmuster-modal__close--step2");

    function setOrderModalStep(step) {
      if (!orderModal) return;
      var isStep2 = step === 2;
      orderModal.setAttribute("data-step", String(step));
      if (orderCloseStep2) {
        orderCloseStep2.hidden = !isStep2;
        orderCloseStep2.setAttribute("aria-hidden", isStep2 ? "false" : "true");
      }
    }

    function openOrderModal() {
      if (!orderModal) return;
      var allSlots = container.querySelectorAll(".bd-stoffmuster-sticky-bar__slot");
      var orderedSlots = [];
      for (var i = 0; i < allSlots.length; i++) {
        orderedSlots.push(allSlots[i]);
      }
      if (orderSwatchesWrapper) {
        orderSwatchesWrapper.innerHTML = "";
        orderedSlots.forEach(function (slot) {
          var wrap = document.createElement("div");
          wrap.className = "bd-stoffmuster-order-modal__swatch";
          var img = slot.classList.contains("bd-stoffmuster-sticky-bar__slot--filled") ? slot.querySelector("img") : null;
          if (img && img.src) {
            var cl = document.createElement("img");
            cl.src = img.src;
            cl.alt = img.alt || "";
            wrap.appendChild(cl);
          } else {
            wrap.classList.add("bd-stoffmuster-order-modal__swatch--empty");
            var emptyImg = document.createElement("img");
            emptyImg.src = emptySlotSvgUrl;
            emptyImg.alt = "";
            emptyImg.setAttribute("aria-hidden", "true");
            wrap.appendChild(emptyImg);
          }
          var slide = document.createElement("div");
          slide.className = "swiper-slide";
          slide.appendChild(wrap);
          orderSwatchesWrapper.appendChild(slide);
        });
        if (orderSwatchesContainer && typeof Swiper !== "undefined") {
          if (orderSwatchesContainer.swiper) orderSwatchesContainer.swiper.destroy(true, true);
          new Swiper(orderSwatchesContainer, {
            slidesPerView: "auto",
            spaceBetween: 28,
            freeMode: true,
            grabCursor: true,
            resistanceRatio: 0,
            touchReleaseOnEdges: true
          });
        }
      }
      if (orderStep1) orderStep1.classList.add("bd-stoffmuster-order-modal__step--active");
      if (orderStep2) orderStep2.classList.remove("bd-stoffmuster-order-modal__step--active");
      setOrderModalStep(1);
      orderModal.setAttribute("aria-hidden", "false");
      document.body.classList.add("bd-stoffmuster-modal-open");
    }

    function closeOrderModal() {
      if (!orderModal) return;
      if (orderStep1) orderStep1.classList.add("bd-stoffmuster-order-modal__step--active");
      if (orderStep2) orderStep2.classList.remove("bd-stoffmuster-order-modal__step--active");
      setOrderModalStep(1);
      orderModal.setAttribute("aria-hidden", "true");
      document.body.classList.remove("bd-stoffmuster-modal-open");
    }

    var ctaEl = container.querySelector("[data-sticky-bar-cta]");
    if (ctaEl) {
      ctaEl.addEventListener("click", function (e) {
        e.preventDefault();
        if (ctaEl.getAttribute("aria-disabled") === "true") return;
        openOrderModal();
      });
    }
    updateCtaState();

    if (orderModal) {
      orderModal.querySelectorAll("[data-stoffmuster-modal-close][data-modal-target=\"bd-stoffmuster-order-modal\"]").forEach(function (btn) {
        btn.addEventListener("click", function () {
          closeOrderModal();
        });
      });
      var orderOverlay = orderModal.querySelector(".bd-stoffmuster-modal__overlay");
      if (orderOverlay) orderOverlay.addEventListener("click", closeOrderModal);
    }

    if (orderForm) {
      var orderErrorEl = orderModal && orderModal.querySelector("[data-order-error]");
      var orderErrorRowEl = orderModal && orderModal.querySelector("[data-order-error-row]");
      var emailInput = orderForm.querySelector('[name="email"]');
      var requiredInputs = orderForm.querySelectorAll("[required]");
      var emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

      function showError(message) {
        if (orderErrorEl) orderErrorEl.textContent = message;
        if (orderErrorRowEl) orderErrorRowEl.setAttribute("aria-hidden", "false");
      }

      function setFieldInvalid(input) {
        var field = input && input.closest(".bd-stoffmuster-order-modal__field");
        if (field) field.classList.add("bd-stoffmuster-order-modal__field--invalid");
        if (input) input.setAttribute("aria-invalid", "true");
      }

      function clearFieldInvalid(input) {
        var field = input && input.closest(".bd-stoffmuster-order-modal__field");
        if (field) field.classList.remove("bd-stoffmuster-order-modal__field--invalid");
        if (input) input.removeAttribute("aria-invalid");
      }

      function clearInvalid() {
        requiredInputs.forEach(clearFieldInvalid);
        if (orderErrorEl) orderErrorEl.textContent = "";
        if (orderErrorRowEl) orderErrorRowEl.setAttribute("aria-hidden", "true");
      }

      requiredInputs.forEach(function (input) {
        input.addEventListener("input", function () {
          clearFieldInvalid(input);
          if (!orderForm.querySelector(".bd-stoffmuster-order-modal__field--invalid")) {
            if (orderErrorEl) orderErrorEl.textContent = "";
            if (orderErrorRowEl) orderErrorRowEl.setAttribute("aria-hidden", "true");
          }
        });
      });

      orderForm.addEventListener("submit", function (e) {
        e.preventDefault();
        var webappUrl = orderModal.getAttribute("data-order-webapp-url");
        var errorMessage = orderModal.getAttribute("data-order-error-message") || "Bestellung konnte nicht gesendet werden. Bitte später erneut versuchen.";
        var requiredErrorMessage = orderModal.getAttribute("data-order-required-error-message") || "Bitte fülle alle Pflichtfelder aus.";
        var emailErrorMessage = orderModal.getAttribute("data-order-email-error-message") || "Bitte gib eine gültige E-Mail-Adresse ein.";
        clearInvalid();
        var firstInvalidInput = null;
        requiredInputs.forEach(function (input) {
          if (!input.value.trim()) {
            setFieldInvalid(input);
            if (!firstInvalidInput) firstInvalidInput = input;
          }
        });
        if (firstInvalidInput) {
          showError(requiredErrorMessage);
          firstInvalidInput.focus();
          return;
        }
        var emailValue = emailInput ? emailInput.value.trim() : "";
        if (!emailRegex.test(emailValue)) {
          setFieldInvalid(emailInput);
          showError(emailErrorMessage);
          if (emailInput) emailInput.focus();
          return;
        }
        if (!webappUrl || webappUrl.trim() === "") {
          if (orderStep1) orderStep1.classList.remove("bd-stoffmuster-order-modal__step--active");
          if (orderStep2) orderStep2.classList.add("bd-stoffmuster-order-modal__step--active");
          setOrderModalStep(2);
          return;
        }
        var artikel = [];
        container.querySelectorAll(".bd-stoffmuster-sticky-bar__slot.bd-stoffmuster-sticky-bar__slot--filled").forEach(function (slot) {
          artikel.push({
            name: (slot.getAttribute("data-article-name") || "").trim(),
            number: (slot.getAttribute("data-article-number") || "").trim()
          });
        });
        var params = new URLSearchParams();
        params.append("K_Firma", "MDS Handels- und Dienstleistungs-GmbH");
        params.append("K_Firmenzusatz", "Livinda Store");
        params.append("K_Straße und Nr.", "Hammersteinstraße 1");
        params.append("K_Adresszusatz", "");
        params.append("K_PLZ", "47807");
        params.append("K_Ort", "Krefeld");
        params.append("K_Land", "Deutschland");
        params.append("K_E-mail-Adresse", "info@livinda.de");
        params.append("L_Vorname", (orderForm.querySelector('[name="first_name"]') || {}).value || "");
        params.append("L_Nachname", (orderForm.querySelector('[name="last_name"]') || {}).value || "");
        params.append("L_Firma", "");
        params.append("L_Firmenzusatz", "");
        params.append("L_Straße und Nr.", (orderForm.querySelector('[name="address1"]') || {}).value || "");
        params.append("L_PLZ", (orderForm.querySelector('[name="zip"]') || {}).value || "");
        params.append("L_Ort", (orderForm.querySelector('[name="city"]') || {}).value || "");
        params.append("L_Land", (orderForm.querySelector('[name="country"]') || {}).value || "");
        params.append("L_E-mail-Adresse", (orderForm.querySelector('[name="email"]') || {}).value || "");
        artikel.forEach(function (item) {
          params.append("Artikelname", item.name);
          params.append("Artikelnummer", item.number);
        });
        var submitBtn = orderForm.querySelector('button[type="submit"]') || orderModal.querySelector(".bd-stoffmuster-order-modal__submit");
        var submittingText = "Wird bestellt…";
        if (submitBtn) {
          var defaultText = submitBtn.textContent;
          submitBtn.disabled = true;
          submitBtn.textContent = submittingText;
        }
        fetch(webappUrl.trim(), {
          method: "POST",
          headers: { "Content-Type": "application/x-www-form-urlencoded" },
          body: params.toString()
        })
          .then(function (res) {
            return res.text().then(function (text) {
              var data = {};
              try { data = text ? JSON.parse(text) : {}; } catch (err) {}
              return { ok: res.ok, data: data };
            });
          })
          .catch(function () { return { ok: false, data: {} }; })
          .then(function (result) {
            if (submitBtn) {
              submitBtn.disabled = false;
              submitBtn.textContent = defaultText;
            }
            if (result.ok && result.data && result.data.success) {
              clearAll();
              orderForm.reset();
              if (orderStep1) orderStep1.classList.remove("bd-stoffmuster-order-modal__step--active");
              if (orderStep2) orderStep2.classList.add("bd-stoffmuster-order-modal__step--active");
              setOrderModalStep(2);
            } else {
              if (orderErrorEl) orderErrorEl.textContent = errorMessage;
              if (orderErrorRowEl) orderErrorRowEl.setAttribute("aria-hidden", "false");
            }
          });
      });
    }

    document.addEventListener("keydown", function (e) {
      if (e.key !== "Escape") return;
      if (orderModal && orderModal.getAttribute("aria-hidden") === "false") {
        closeOrderModal();
      }
    });
  }

  function initSplitContentCircleScroll(container) {
    var circle = container.querySelector(".split-content-image-block__circle");
    if (!circle) return;

    circle.addEventListener("click", function () {
      var target = document.querySelector("div.bd-stoffmuster-selection");
      if (!target) return;
      var offset = 100;
      var offsetPosition = target.getBoundingClientRect().top + window.pageYOffset - offset;
      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth"
      });
    });
  }

  document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll(".bd-stoffmuster-header[data-section-id]").forEach(initHeaderSection);
    document.querySelectorAll(".bd-stoffmuster-media[data-section-id]").forEach(BD_StoffMuster_Media);
    document.querySelectorAll(".bd-stoffmuster-material[data-section-id]").forEach(BD_StoffMuster_Material);
    document.querySelectorAll(".bd-stoffmuster-selection").forEach(BD_Stoffmuster_Selection);
    document.querySelectorAll(".bd-stoffmuster-split-content-image").forEach(initSplitContentCircleScroll);
    var stickyBar = document.getElementById("bd-stoffmuster-sticky-bar");
    if (stickyBar) BD_StoffMuster_Sticky_Bar(stickyBar);
  });
})();
